// extracted by mini-css-extract-plugin
export var phone = "_4z-0";
export var phoneDragging = "_4z-1";